// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React, { useEffect } from 'react';
import I18n from 'i18n-js';
import { isNil } from 'lodash';
import { Location } from 'history';

import Item2Feedback from './item2_feedback';
import FeedbackSummary from './discovery/feedback_summary';
import { RCStarRating, RCAccordion } from '@reverbdotcom/cadence/components';
import { Paths } from './shared/url_helpers';
import { V3 } from './api_request';
import { Item2ShopReviewsData } from '@reverbdotcom/commons/src/gql/graphql';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

export const Item2ShopReviewsFragment = gql`
  fragment Item2ShopReviewsData on Listing {
    _id
    sellerUuid
    shop {
      _id
      id
    }
    seller {
      _id
      feedbackSummary {
        receivedCount
        rollingRatingPercentage
      }
    }
  }
`;

interface IProps {
  listing: Item2ShopReviewsData.Fragment;
  location?: Location;
  heading?: string;
}

function AdditionalHeadingContent({ feedbackSummary }) {
  const rating = feedbackSummary.rollingRatingPercentage;
  const ratingCount = feedbackSummary.receivedCount;
  const shouldRenderStarRating = !(isNil(rating) || isNil(ratingCount));
  if (!shouldRenderStarRating) return;

  return (
    <RCStarRating
      rating={rating / 100}
      count={ratingCount}
      hideTooltip
    />
  );
}

// configure click tracking function for Accordion Event
const trackClick = (collapsed, componentName, listing) => {
  trackEvent({
    eventName: MParticleEventName.ClickedAccordion,
    componentName,
    listing,
    interactionType: collapsed ? 'collapse' : 'expand',
  });
};

export function Item2ShopReviews({
  listing,
  location,
  heading,
}: IProps) {
  const [feedbackSummaryData, setFeedbackSummaryData] = React.useState<FeedbackSummary | null>(null);
  const { seller } = listing;
  const shopReviewsApiPath = Paths.apiFeedbackSummary.expand({ slug: listing?.shop?.id });

  useEffect(() => {
    V3.get(shopReviewsApiPath)
      .then(response => {
        setFeedbackSummaryData(response);
      })
      .fail(err => {
        throw (err);
      });
  }, []);

  if (!listing) return null;
  if (!seller?.feedbackSummary?.receivedCount) return null;

  return (
    <div id="shop-reviews">
      <RCAccordion
        data-item2-description-seller-review
        heading={
          <div className="d-flex fx-align-center gap-2 mobile-d-block">
            <RCAccordion.Heading
              text={heading || I18n.t('discovery.item2Description.shopReviews')}
            />
            <AdditionalHeadingContent
              feedbackSummary={seller.feedbackSummary}
            />
          </div>
        }
        defaultOpen={Object.keys(location?.query).includes('page')}
        id="shop-reviews"
        onToggle={(collapsed) => trackClick(collapsed, 'Item2ShopReviews', listing)}
      >
        <Item2Feedback
          sellerUuid={listing.sellerUuid}
          feedbackSummaryData={feedbackSummaryData}
        />
      </RCAccordion>
    </div>
  );
}
